import { render, staticRenderFns } from "./CHeaderProfileMenu.vue?vue&type=template&id=2e24fa0c&scoped=true&"
import script from "./CHeaderProfileMenu.vue?vue&type=script&lang=js&"
export * from "./CHeaderProfileMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e24fa0c",
  null
  
)

export default component.exports